<div class="pt-8">
  <ng-template [ngIf]="text.length > 0">
      <p class="small mb-4">
          <em>{{ text }}</em>
      </p>
  </ng-template>
  <ng-template [ngIf]="items && items.length > 0">
      <ul class="small list-inside list-disc">
        <ng-container *ngFor="let item of items">
          <li>
            {{ item }}
        </li>
        </ng-container>
      </ul>
  </ng-template>
</div>
